<div class="datatable-pagination">
  <div class="datatable-select-wrapper">
    <p class="datatable-select-text">{{ rowsPerPageText }}:</p>
    <mdb-form-control>
      <mdb-select
        [value]="showAllEntries ? (entries === total ? allText : entries) : entries"
        (selected)="updateRowPerPageNumber($event)"
        [disabled]="disabled"
      >
        <mdb-option *ngFor="let entry of entriesOptions" [value]="entry">{{ entry }}</mdb-option>
        <mdb-option *ngIf="showAllEntries" [value]="allText">{{ allText }}</mdb-option>
      </mdb-select>
    </mdb-form-control>
  </div>
  <div class="datatable-pagination-nav">{{ getPaginationRangeText() }}</div>

  <div class="datatable-pagination-buttons">
    <button
      type="button"
      class="btn btn-link datatable-pagination-button datatable-pagination-left"
      [ngClass]="{ disabled: disabled || isPreviousPageDisabled() || prevButtonDisabled }"
      [disabled]="disabled || isPreviousPageDisabled() || prevButtonDisabled"
      (click)="previousPage()"
    >
      <i class="fa fa-chevron-left"></i>
    </button>

    <button
      type="button"
      class="btn btn-link datatable-pagination-button datatable-pagination-right"
      [ngClass]="{ disabled: disabled || isNextPageDisabled() || nextButtonDisabled }"
      [disabled]="disabled || isNextPageDisabled() || nextButtonDisabled"
      (click)="nextPage()"
    >
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
</div>
